import { useEffect, useRef } from 'react';

const SCRIPT_ID = 'turnstile-script';
const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

const TurnstileWidget = ({ onVerify, className = '' }) => {
    const containerRef = useRef(null);
    const widgetIdRef = useRef(null);

    useEffect(() => {
        let attempts = 0;
        const maxAttempts = 50;

        const renderWidget = () => {
            if (!containerRef.current) return;

            if (window.turnstile) {
                if (widgetIdRef.current) {
                    window.turnstile.reset(widgetIdRef.current);
                }
                widgetIdRef.current = window.turnstile.render(containerRef.current, {
                    sitekey: SITE_KEY,
                    callback: (token) => onVerify && onVerify(token),
                    'expired-callback': () => onVerify && onVerify(null),
                });
            } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(renderWidget, 100);
            }
        };

        if (!document.getElementById(SCRIPT_ID)) {
            const script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }

        renderWidget();

        return () => {
            if (widgetIdRef.current && window.turnstile) {
                window.turnstile.remove(widgetIdRef.current);
                widgetIdRef.current = null;
            }
        };
    }, [onVerify]);

    return <div ref={containerRef} className={className} />;
};

export default TurnstileWidget;